import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { HeaderStyled, SummaryContainer } from './TrlScreenSummary.styled';

export const TrlScreenSummary = ({
  title,
  hasTopMargin,
  bottomMargin,
  children,
}) => (
  <SummaryContainer
    id="screenSummaryContainer"
    hasTopMargin={hasTopMargin}
    bottomMargin={bottomMargin}
  >
    <HeaderStyled>
      <FormattedMessage id={title} />
    </HeaderStyled>
    {children}
  </SummaryContainer>
);

TrlScreenSummary.propTypes = {
  title: PropTypes.string,
  hasTopMargin: PropTypes.bool,
  bottomMargin: PropTypes.number,
  children: PropTypes.element,
};
